"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var softLockModalStyles_1 = require("./softLockModalStyles");
var ModalWithHeader_1 = require("../../../../common/components/presentation/ModalWithHeader/ModalWithHeader");
var useGqlNav_1 = require("../../../common/hooks/useGqlNav");
var react_intl_1 = require("react-intl");
var clsx_1 = require("clsx");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var ShowIfTranslationExists_1 = require("../../../../common/components/ShowIfTranslationExists");
var useGetConfigurationUrl_1 = require("../../../common/hooks/useGetConfigurationUrl");
var useUserComingFromMyAccount_1 = require("../../hooks/useUserComingFromMyAccount");
var SoftLockModal = function (_a) {
    var handleContinueBtn = _a.handleContinueBtn, onClose = _a.onClose, isOpen = _a.isOpen, softLockedErrorMsg = _a.softLockedErrorMsg, isErrorPaymentInitSoftLock = _a.isErrorPaymentInitSoftLock;
    var styles = softLockModalStyles_1.default();
    var intl = react_intl_1.useIntl();
    var history = useGqlNav_1.useGqlNav().history;
    var hideSoftLockHeaderTitle = usePlatformConfig_1.default().platformConfig.platformFeatures.hideSoftLockHeaderTitle;
    var getConfigurationUrl = useGetConfigurationUrl_1.default().getConfigurationUrl;
    var isUserComingFromMyAccount = useUserComingFromMyAccount_1.default().isUserComingFromMyAccount;
    var handleBackButton = function () {
        if (isUserComingFromMyAccount) {
            history.goBack();
        }
        else {
            window.location.href = getConfigurationUrl();
        }
    };
    var errorMessage = react_1.useMemo(function () {
        if (hideSoftLockHeaderTitle) {
            if (isErrorPaymentInitSoftLock) {
                return softLockedErrorMsg;
            }
            return 'trans__checkout__out_of_stock_modal__error_message_label';
        }
        return 'trans__checkout__out_of_stock_modal__customer_message';
    }, [hideSoftLockHeaderTitle, isErrorPaymentInitSoftLock]);
    var headerTitle = hideSoftLockHeaderTitle ? null : (<Translation_1.default id={'trans__checkout__out_of_stock_modal__error_message_label'}/>);
    return (<ModalWithHeader_1.default open={isOpen} title={headerTitle} data-test="modal:soft_lock" toggleModal={onClose}>
      <core_1.Grid container className={styles.root} data-test="modal:soft_lock:content">
        <ShowIfTranslationExists_1.default translationKey={errorMessage}>
          <core_1.Typography dangerouslySetInnerHTML={{
        __html: intl.formatMessage({
            id: errorMessage,
        }),
    }} className={styles.message} data-test="modal:soft_lock:errorMessage"/>
        </ShowIfTranslationExists_1.default>
        <core_1.Grid item xs={12} md={6} className={styles.buttonContainer}>
          <core_1.Button className={styles.button} data-test="button:soft_lock_back" onClick={handleBackButton} variant="outlined">
            <Translation_1.default id="trans__checkout__out_of_stock_modal__back_CTA"/>
          </core_1.Button>
          {handleContinueBtn && (<core_1.Button className={clsx_1.default(styles.button, styles.softLockContinueBtn)} data-test="button:soft_lock_continue" onClick={handleContinueBtn} variant="outlined">
              <Translation_1.default id="trans__checkout__next_step__continue_CTA"/>
            </core_1.Button>)}
        </core_1.Grid>
      </core_1.Grid>
    </ModalWithHeader_1.default>);
};
exports.default = SoftLockModal;
